import Vue from 'vue'
import VueMoment from 'vue-moment'

// import moment from 'moment-timezone'
// require('moment/locale/da')
// moment.tz.setDefault('Europe/Copenhagen')
// Vue.use(VueMoment, { moment })
Vue.use(VueMoment)